import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-359ee2be"), n = n(), _popScopeId(), n);
const _hoisted_1 = { key: 0 };
import { ref } from 'vue';
import Menu from 'primevue/menu';
import { AppStore } from '@apparatix/stores/AppStore';
import ChevronDownIcon from '@apparatix/icons/ChevronDownIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'NavigationOverflowDropdown',
    setup(__props) {
        const menuRef = ref();
        const toggleMenu = (e) => menuRef.value.toggle(e);
        return (_ctx, _cache) => {
            return (_unref(AppStore).overflowNavigation.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("button", {
                        class: "navigation-overflow-button",
                        onClick: toggleMenu
                    }, [
                        _createTextVNode(" More "),
                        _createElementVNode("span", null, [
                            _createVNode(ChevronDownIcon)
                        ])
                    ]),
                    _createVNode(_unref(Menu), {
                        ref_key: "menuRef",
                        ref: menuRef,
                        model: _unref(AppStore).overflowNavigation,
                        popup: true
                    }, null, 8, ["model"])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
